import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';
import { TariffStatus, TariffType } from '../types';

export const tariffsListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'name',
    label: 'Name',
  },
  {
    name: 'riskScoreRangeId',
    label: 'Risk score',
  },
  {
    name: 'type',
    label: 'Type',
  },
  {
    name: 'status',
    label: 'Status',
    filterModalPlacement: 'right',
  },
];

export const tariffsListColumnsLabels = {
  status: 'Status',
  name: 'Name',
  type: 'Type',
  riskScoreRangeId: 'Risk Score',
};

export const tariffsListDefaultSorter = {};

export const tariffsListSchema = {
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  name: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  type: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  riskScoreRangeId: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const tariffsListFiltersSchema = [
  {
    name: 'name',
    type: FilterType.TEXT,
    placeholder: 'Enter name',
  },
  {
    name: 'riskScoreRangeId',
    type: FilterType.AUTOCOMPLETE,
    placeholder: 'Search by risk score',
  },
  {
    name: 'status',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'status',
        title: 'Draft',
        value: TariffStatus.DRAFT,
      },
      {
        name: 'status',
        title: 'Archived',
        value: TariffStatus.ARCHIVED,
      },
      {
        name: 'status',
        title: 'Published',
        value: TariffStatus.PUBLISHED,
      },
    ],
  },
  {
    name: 'type',
    type: FilterType.RADIO,
    fields: [
      {
        name: 'type',
        title: 'Individual',
        value: TariffType.INDIVIDUAL,
      },
      {
        name: 'type',
        title: 'Corporate',
        value: TariffType.CORPORATE,
      },
    ],
  },
];
